export const KEY_STORAGE = {
  LANGUAGE: 'LANGUAGE',
  USER: 'USER',
  DISPLAY_REPORT_LIST: 'DISPLAY_REPORT_LIST',
  TOKEN: 'TOKEN',
}
